import { useCallback, useEffect, useState } from "react";
import { LineChart, ScrollText } from "lucide-react";
import { Card } from "@/components/common/PageHeader";
import { Loading, Stat } from "@/pages/_shared";
import api from "@/lib/api";

export default function ActivityReports() {
  const [data, setData] = useState(null);
  const [kind, setKind] = useState("all");
  const load = useCallback((k) => { api.get(`/activity/log${k && k !== "all" ? `?kind=${encodeURIComponent(k)}` : ""}`).then(({ data }) => setData(data)); }, []);
  useEffect(() => { load(kind); }, [load, kind]);
  if (!data) return <Loading />;
  const { events, classes, summary } = data;

  return (
    <div className="animate-fade-up space-y-6" data-testid="activity-page">
      <div>
        <h1 className="flex items-center gap-2 font-head text-2xl font-extrabold tracking-tight text-slate-900"><LineChart size={22} className="text-[#b0862f]" /> Activity & Reports</h1>
        <p className="mt-1 text-[13px] text-slate-500">A complete audit trail of what your AI workforce and you have done — who, what, when.</p>
      </div>

      <div className="grid gap-3 sm:grid-cols-4">
        <Stat label="Total events" value={summary.total} tone="slate" />
        <Stat label="Today" value={summary.today} tone="blue" />
        <Stat label="AI actions" value={summary.ai_actions} tone="green" />
        <Stat label="Owner actions" value={summary.owner_actions} tone="slate" />
      </div>

      <div className="flex flex-wrap gap-2">
        {["all", ...classes].map((c) => (
          <button key={c} onClick={() => setKind(c)} data-testid={`activity-filter-${c}`}
            className={`rounded-lg px-3 py-1.5 font-mono text-[11px] font-semibold uppercase tracking-wider transition-colors ${kind === c ? "bg-[#080d1a] text-white" : "border border-slate-200 bg-white text-slate-500"}`}>{c}</button>
        ))}
      </div>

      <Card className="p-5" data-testid="activity-log">
        <div className="mb-3 flex items-center gap-2"><ScrollText size={15} className="text-[#1a5fd0]" /><span className="font-head text-[14px] font-bold text-slate-900">Audit trail</span></div>
        {events.length === 0 ? <div className="py-8 text-center text-[13px] text-slate-400">No activity for this filter.</div> : (
          <div className="space-y-2">
            {events.map((e, i) => (
              <div key={i} className="flex items-center justify-between gap-3 border-b border-slate-50 py-2 text-[13px] last:border-0" data-testid="activity-event">
                <span className="min-w-0 text-slate-700"><b>{e.actor}</b> · {e.action}</span>
                <span className="flex shrink-0 items-center gap-2">
                  <span className="rounded bg-slate-100 px-1.5 py-0.5 font-mono text-[9px] uppercase tracking-wider text-slate-500">{e.data_class}</span>
                  <span className="font-mono text-[10px] text-slate-400">{String(e.when).slice(0, 16).replace("T", " ")}</span>
                </span>
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
}
